<template>
  <v-base-question
    :url="$laravel.route('api.users.answer_quiz.fly')"
    :data="form"
    previous="quiz.commute"
    next="quiz.eat"
    icon="/img/icons/svg/plane.svg"
  >
    <v-input-number
      v-model="form.quiz_fly"
      name="quiz_fly"
      label="How much do you fly? (hours)"
      input-class="w-full"
      :min="0"
      :max="100"
      :step="1"
    />
  </v-base-question>
</template>
<script>
import baseQuestionVue from "./baseQuestion.vue";
export default {
  name: "v-quiz-fly",
  components: {
    "v-base-question": baseQuestionVue
  },
  data() {
    return {
      form: {
        quiz_fly: 0
      }
    };
  },
};
</script>
